<template>
  <div class="relative">
    <section class="h-[70vh] md:h-[100vh] bg-[url('@/assets/home-bg.png')] bg-cover flex flex-col">
    <MainHeader/>
    <div class="flex items-center h-full">
      <div class="container mx-auto flex flex-col px-6 md:px-0">
        <h1 class="text-4xl md:text-7xl font-medium">#Amplify your reach </h1>
        <div class="text-2xl md:text-6xl italic mt-3 mb-6">with Influencer Partnerships</div>
        <span class="text-lg md:text-4xl font-tisa">The #1 sales gamification platform<br/>to maximize your revenue.</span>
        <div class="flex">
          <o-button
            @click="showSignUpModel"
            variant="primary-large"
            type="button"
            class="mt-6 md:mt-12">
            Join The Alpha
          </o-button>
        </div>
      </div>
    </div>
    </section>
    <section class="container mx-auto px-6 md:px-0 flex flex-col items-center justify-center py-16" id="Influencer">
      <h2 class="text-2xl md:text-4xl font-medium mb-8 md:mb-0">An <span class="text-orange-300">Influencer Marketplace</span> that</h2>
      <div class="grid md:grid-rows-3 grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-12 md:w-[80%] items-center">
        <div class="order-1">
          <h3 class="text-lg md:text-2xl font-bold mb-4">Removes Barriers to Entry</h3>
          <p class="md:text-xl">Aspiring and current influencers can freely join the platform without hassle. Easy sign-up process with very low entry requirements.</p>
        </div>
        <div class="order-2">
          <img src="@/assets/home-influencer-0.png" alt="Influencers Marketplace">
        </div>
        <div class="order-4 md:order-3">
          <img src="@/assets/home-influencer-1.png" alt="Influencers Marketplace">
        </div>
        <div class="order-3 md:order-4">
          <h3 class="text-lg md:text-2xl font-bold mb-4">Connects Influencers &<br/>Amplifies Sales Impact</h3>
          <p class="md:text-xl">Create connections with other influencers in the platform and apply the campaign to compete the game together!</p>
        </div>
        <div class="order-5">
          <h3 class="text-lg md:text-2xl font-bold mb-4">Provides Clear<br/>Compensation</h3>
          <p class="md:text-xl">Clear way of earning money every step of the way. Easy tracking of sales and commission during campaign. Tracks everything down to the wire! </p>
          <o-button
            @click="showSignUpModel(ROLE.Influencer)"
            variant="primary-large"
            type="button"
            class="mt-6 md:mt-12">
            Join The Alpha
          </o-button>
        </div>
        <div class="order-6">
          <img src="@/assets/home-influencer-2.png" alt="Influencers Marketplace">
        </div>
      </div>
    </section>
    <section class="bg-indigo-10" id="Business">
      <div class="container mx-auto px-6 md:px-0 flex flex-col items-center justify-center py-16">
        <h2 class="text-2xl md:text-4xl font-medium mb-8 md:mb-12">Business Sales Solution</h2>
        <div class="grid md:grid-rows-2 grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-16 md:w-[80%] items-center">
          <div class="order-1">
            <h3 class="text-lg md:text-2xl font-bold mb-4">Hybrid Marketing &<br/>Stable Return on Ad Spend (ROAS)</h3>
            <p class="md:text-xl">Creates a stable return on ads spent. Company no long need to worry about costs, only inventory amount. Our platform will be using sales as the main metric of measurement.</p>
          </div>
          <div class="order-2">
            <img src="@/assets/home-business-0.png" alt="Business Solution">
          </div>
          <div class="order-4 md:order-3">
            <img src="@/assets/home-business-1.png" alt="Business Solution">
          </div>
          <div class="order-3 md:order-4">
            <h3 class="text-lg md:text-2xl font-bold mb-4">Replace Budget with Sales Goals</h3>
            <p class="md:text-xl">Companies no longer need to worry about budget for marketing expenses. Only Sales! Sales! Sales! </p>
            <o-button
              @click="showSignUpModel(ROLE.Business)"
              variant="primary-large"
              type="button"
              class="mt-6 md:mt-12">
              Join The Alpha
            </o-button>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-[url('@/assets/home-bottom-bg.png')] bg-bottom bg-cover py-[100px]">
      <div class="container mx-auto flex flex-col md:flex-row justify-between items-center md:w-[80%]">
        <div class="mb-8 md:mb-0">
          <h2 class="text-[22px] md:text-4xl font-medium mb-1 md:mb-2">Building influencers, driving sales.</h2>
          <div class="text-[22px] md:text-4xl italic font-light">Our expertise, Your success.</div>
        </div>
        <o-button
          @click="showSignUpModel(ROLE.Influencer)"
          variant="black-large"
          type="button"
          class="">
          Join the Community Now
        </o-button>
      </div>
    </section>
    <MainFooter
      @signUp="showSignUpModel"
    />
  </div>
</template>

<script>
import MainHeader from '@/components/layout/MainHeader.vue'
import MainFooter from '@/components/layout/MainFooter.vue'
// import SignUpForm from '@/components/SignUpForm.vue'
import { ROLE } from '@/data/default'

export default {
  components: {
    MainHeader,
    MainFooter
  },
  data() {
    return {
      ROLE,
    }
  },
  methods: {
    showSignUpModel() {
      window.open('https://forms.gle/jKwc7WqxyhDpxJH67', '_blank')
      // this.$oruga.modal.open({
      //   component: SignUpForm,
      //   props: {
      //     roleProp: role,
      //   },
      //   trapFocus: true,
      //   contentClass: 'rounded-[2.5rem]',
      //   mobileClass: 'px-4'
      // })
    },
  },
}
</script>
